<template>
  <ListGroupItem>
    <div class="flex-1 text-break">
      <div>{{ props.zone.name }}</div>
    </div>
    <div class="form-switch me-n1">
      <input
        type="checkbox"
        class="form-check-input"
        id="customSwitch2"
        @change="() => props.handleShareChange(props.zone._id)"
        :checked="props.zone.shared"
      />
      <label class="form-check-label" for="customSwitch2"></label>
    </div>
  </ListGroupItem>
</template>

<script setup>
import { reactive, getCurrentInstance, defineProps, computed } from 'vue';
import Axios, { AuthApi } from '@/api';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';

const props = defineProps(['zone', 'user', 'handleShareChange']);
</script>
